import React, { Component, Fragment } from "react";
import DrillDown from "../../../../d3Components/drillDownPie/drillDown";
import {
  modifyDataDrill,
  drillDownModify,
} from "../../../../pages/compare/commonFunctions";
import WithCard from "../../../../common/withCard";

class DrillDownHolder extends Component {
  state = {
    drill1: [],
    drill2: [],
    option1: [],
    option2: [],
  };
  componentDidMount() {
    var data1 = this.props.lastLivePort;
    var data2 = this.props.lastCurrPort;

    // chart data
    var drill1 = modifyDataDrill(data1);
    var drill2 = modifyDataDrill(data2);

    // chart options
    var option1 = drillDownModify(data1);
    var option2 = drillDownModify(data2);

    this.setState({
      drill1,
      drill2,
      option1,
      option2,
    });
  }
  componentWillReceiveProps(nextProps) {
    var data1 = nextProps.lastLivePort;
    var data2 = nextProps.lastCurrPort;

    // chart data
    var drill1 = modifyDataDrill(data1);
    var drill2 = modifyDataDrill(data2);

    // chart options
    var option1 = drillDownModify(data1);
    var option2 = drillDownModify(data2);

    this.setState({
      drill1,
      drill2,
      option1,
      option2,
    });
  }
  render() {
    const { drill1, drill2, option1, option2 } = this.state;
    const { id1, id2, header1, header2 } = this.props;

    return (
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <WithCard>
              {drill1.length ? (
                <Fragment>
                  {header1 ? (
                    <div className="universe__table-title">{header1}</div>
                  ) : null}
                  <DrillDown
                    id={id1}
                    idInner={"DrillRebInn"}
                    width={610}
                    height={350}
                    chartData={drill1}
                    chartOptions={option1}
                    updateLegend={this.props.ORIG_LEGEND}
                  />
                </Fragment>
              ) : null}
            </WithCard>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <WithCard>
              {drill2.length ? (
                <Fragment>
                  {header2 ? (
                    <div className="universe__table-title">{header2}</div>
                  ) : null}
                  <DrillDown
                    id={id2}
                    idInner={"DrillRebInn2"}
                    width={610}
                    height={350}
                    chartData={drill2}
                    chartOptions={option2}
                    updateLegend={this.props.IQCIO_LEGEND}
                  />
                </Fragment>
              ) : null}
            </WithCard>
          </div>
        </div>
      </div>
    );
  }
}

export default DrillDownHolder;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Rebalance/section1/drillDownHolder.jsx